document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.inova-faq-item').forEach(function (item) {
    var btn = item.querySelector('.inova-faq-question');
    var answer = item.querySelector('.inova-faq-answer');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.closest('.inova-faq-list').querySelectorAll('.inova-faq-item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.inova-faq-answer').style.maxHeight = null;
        }
      });
      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
  var stickyBar = document.querySelector('.inova-sticky-buybar');
  var mainForm = document.querySelector('[id^="MainProduct-"] .product-form__buttons');
  if (stickyBar && mainForm) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(mainForm);
    var stickyAddBtn = stickyBar.querySelector('[data-inova-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        var realSubmit = document.querySelector('[id^="MainProduct-"] button[name="add"]');
        if (realSubmit) realSubmit.click();
      });
    }
  }
});
